import { ClientProviderEvents } from '@openfeature/core';
import { useEffect, useState } from 'react';
import { useFeatureFlagProvider } from './ProvideFeatureFlags';

/**
 * Returns an array of flag keys where the value is `true`.
 * Re-renders when the provider emits configuration change events.
 */
export const useActiveFeatureFlags = (): string[] => {
  const { provider } = useFeatureFlagProvider();
  const [ activeFlags, setActiveFlags ] = useState<string[]>(() => {
    return computeActiveFlags( provider );
  });

  useEffect(() => {
    if ( !provider ) return;

    // Recompute on mount in case data changed since initial render
    setActiveFlags( computeActiveFlags( provider ));

    const handler = () => {
      setActiveFlags( computeActiveFlags( provider ));
    };

    provider.events.addHandler( ClientProviderEvents.ConfigurationChanged, handler );

    return () => {
      provider.events.removeHandler( ClientProviderEvents.ConfigurationChanged, handler );
    };
  }, [provider]);

  return activeFlags;
};

export const computeActiveFlags = ( provider: { getAllFlags: () => Map<string, boolean> } | null ): string[] => {
  if ( !provider ) return [];

  const flags = provider.getAllFlags();
  const active: string[] = [];
  for ( const [ key, value ] of flags.entries()) {
    if ( value ) {
      active.push( key );
    }
  }
  return active;
};
